import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.address',
        defaultMessage: 'Address'
    },
    propertyDescription: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.propertyDescription',
        defaultMessage: 'Property Description'
    },
    numberOfAcres: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.numberOfAcres',
        defaultMessage: 'Number of Acres'
    },
    isInsuredInvolvedInFarming: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.isInsuredInvolvedInFarming',
        defaultMessage: 'Insured involved in farming at residence or leased property?'
    },
    annualIncome: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.annualIncome',
        defaultMessage: 'Annual Income from Farm and Ranch'
    },
    action: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.modalTitle',
        defaultMessage: 'Add Liability Coverage for Farmland Leased to Others'
    },
    addressLine1: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.liabilityForFarmLandLeased.continueBtn',
        defaultMessage: 'Continue'
    },
});
